'use client';

import { useEffect, useState } from 'react';

import { getMostSearchedGroups, getMostSearchedProcedures } from '@/services/most-searched/most-searched.service';
import { MostSearchedResultType } from '@/types/most-search-type';
import { getLogger } from '@/logger/logger';

const logger = getLogger('use-most-searched-hook');

interface UseMostSearchedReturn {
  groups: MostSearchedResultType[];
  isLoading: boolean;
}

function useMostSearchedFetch(
  fetchGroups: () => Promise<MostSearchedResultType[]>,
): UseMostSearchedReturn {
  const [groups, setGroups] = useState<MostSearchedResultType[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isActive = true;

    fetchGroups()
      .then((fetchedGroups) => {
        if (isActive) {
          setGroups(fetchedGroups);
        }
      })
      .catch((error) => {
        logger.error('Failed to fetch most searched procedures', error);
      })
      .finally(() => {
        if (isActive) {
          setIsLoading(false);
        }
      });

    return () => {
      isActive = false;
    };
  }, [fetchGroups]);

  return { groups, isLoading };
}

export function useMostSearchedGroups(): UseMostSearchedReturn {
  return useMostSearchedFetch(getMostSearchedGroups);
}

export function useMostSearchedProcedures(): UseMostSearchedReturn {
  return useMostSearchedFetch(getMostSearchedProcedures);
}
